import React, { useState, useEffect } from 'react'
import blackLogo from "../../assets/images/blackLogo.png"
import comLogo from "../../assets/images/comLogo.png"
import flag from "../../assets/images/flag.png"
import navtwo from "../../assets/images/navtwo.svg";
import navthree from "../../assets/images/navthree.svg";
// import navfour from "../../assets/images/navfour.svg";
import back from "../../assets/images/back.svg";
import log from "../../assets/images/log.png"
import commbitz from "../../assets/images/commbitz_logo.svg"
import globaltix from "../../assets/images/globaltix.svg"
import { Link } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import styles from "./style.module.css"
// import useAuth from "@/context/AuthContext";

function Header() {
    // const { isAuthenticated, isLoading } = useAuth();

    const [toggle, setToggle] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    return (
      
        <>
          <header>
      
              <div className={styles.menuHead}>
        <nav className="navbar navbar-expand-xl pt-2">
          <div className="container-fluid">
            <Link           
              className="navbar-brand"
              to="/"
            >
              <i className="pe-3 me-lg-3 me-2 border-end broder-light border-2"><Image width="140" height="42" src={comLogo} alt="Commbitz logo" /></i>
              <i><Image width="140" height="56" src={globaltix} alt="Commbitz logo" /></i>
            </Link>
            
             <div className="ml-auto d-flex align-items-center gap-xxl-4 gap-2 flex-lg-row">
              <button
              className="navbar-toggler p-1"
              type="button"
              onClick={() => setToggle(!toggle)}
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                {/* <Image src={ham} alt="" /> */}
              </span>
            </button>
            <div
              className={`${styles.dealscollapseheader} dealscollapseheader collapse navbar-collapse ms-2 ${toggle ? 'show' : ''}`}
              id="navbarSupportedContent"
            >
              <ul className={`${styles.navbar} gap-xxl-3 gap-2`}>
                 <li className={`${styles.navItem}`}>
                  <Link className="nav-Link" to="/country/select-country">
                  eSIM for USA
                  </Link>
                </li>
                   <li
                  className={`${styles.navItem}`}
                >
                  <Link className="nav-Link" to="/country/select-country">
                
                  eSIM for UK
                  </Link>
                </li>
                   <li
                  className={`${styles.navItem}`}
                >
                  <Link className="nav-Link" to="/country/select-country">
                
                  eSIM for Ireland
                  </Link>
                </li>
              </ul>
              {isMobile ? (
                <>
                  <div
                    className="newmobileSidebar"
                    onClick={() => setToggle(!toggle)}
                  >
                    <div className="navback">
                      <span>
                        <Image src={back} alt="" />
                      </span>
                      <h4>PROFILE</h4>
                    </div>
                
                    <ul>
                      <li>
                        <Link className="nav-Link" to="/">
                          <span>
                            <Image src={navtwo} alt="" />
                          </span>
                         HOME
                        </Link>
                      </li>
                      <li>
                        <Link className={`nav-Link`} to="/country/select-country">
                          <span>
                            <Image src={navthree} alt="" />
                          </span>
                          eSIM for USA
                        </Link>
                      </li>
                      <li>
                        <Link className={`nav-Link`} to="/country/select-country">
                          <span>
                            <Image src={navthree} alt="" />
                          </span>
                          eSIM for UK
                        </Link>
                      </li>
                      <li>
                        <a href="/country/select-country">
                          <span>
                            <Image src={navtwo} alt="" />
                          </span>{" "}
                         eSIM for Ireland
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                </>
              ) : (
                false
              )}
         
            </div>
            <div className={styles.loginBtn}>

                <a href="/country/select-country">Claim 1GB Data</a>
            </div>
            </div>
          </div>
        </nav>
       
    </div>
          </header>
        </>
    )
}

export default Header